import React from 'react';
import FeaturedItems from '../../../shared/templates/CategoryTemplate/featured-items';
import JobsFeaturedPreview from './JobsFeaturedPreview';

export default function JobsFeatured(props) {
    return (
        <FeaturedItems 
            {...props}
            FeaturedItemPreview={JobsFeaturedPreview}
        />
    );
}